import React from "react";
import HeaderDisplay from "../common/HeaderDisplay";
import {
  RSSComponent,
  MessageTicker,
  Shabbat,
  Weather,
  StaticScreen,
  CampaignCarousel,
  NeonGrid,
  DidYouKnowSlider,
} from "../../components";

// ייבא את ה-Wrapperים עבור מצב Portrait
import {
  GridContainer,
  TopRow,
  TopRowLeft,
  MiddleCenterColumn,
  ExtraRow,
  BottomRow,
  ParentContainer,
} from "../../assets/wrappers/PublicStylePortrait";

const PortraitScreen = ({
  theme,
  gridRows,
  currentTime,
  dayOfWeek,
  weather,
  address,
  smallCampaign,
  building,
  campaign,
  messages,
  birthdays,
  didYouKnowItems,
  news,
  getResponsiveMargin,
  scheduleViewsMap,
  video,
}) => {
  return (
    <GridContainer
      style={{
        backgroundImage:
          theme.image !== "" ? `url(${theme.image})` : theme.background,
        color: theme.textColor,
        display: "grid",
        gridTemplateRows: gridRows,
      }}
    >
      <TopRow style={{ background: theme.topRowBackground }}>
        <HeaderDisplay
          currentTime={currentTime}
          dayOfWeek={dayOfWeek}
          weather={weather}
          address={address}
          theme={theme}
          video={video}
        />
      </TopRow>

      <TopRowLeft
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "10px",
          padding: "10px",
          alignItems: "start",
        }}
      >
        <ParentContainer>
            <NeonGrid firstColor="#C1CFA1" secondColor="#B1F0F7">
              <CampaignCarousel campaigns={smallCampaign} padding="0px" scheduleViewsMap={scheduleViewsMap}/>
            </NeonGrid>
        </ParentContainer>

        <Shabbat
          margin="10px 0px -10px 25px"
          height={"95%"}
          hebrewCityName={building.city}
          background={theme.shabbat.background}
          borderColor={theme.shabbat.borderColor}
          textColor={theme.shabbat.textColor}
          titleColor={theme.shabbat.titleColor}
          parashaColor={theme.shabbat.parashaColor}
          fontFamily={theme.shabbat.fontFamily}
          image={theme.shabbat.image}
          blurEffect={theme.shabbat.blurEffect}
        />
      </TopRowLeft>

      <MiddleCenterColumn>
        <CampaignCarousel campaigns={campaign} margin={getResponsiveMargin()}
          scheduleViewsMap={scheduleViewsMap}
        />
      </MiddleCenterColumn>

      <ExtraRow>
        <MessageTicker
          key={messages.length}
          initialMessages={messages}
          birthdayMessages={birthdays}
          titleBackground={theme.message.titleBackground}
          textColor={theme.message.textColor}
          background={theme.message.messageBackground}
          neonBackground={theme.message.neonBackground}
          neonText={theme.message.neonText}
          neonColor1={theme.message.neonColor1}
          neonColor2={theme.message.neonColor2}
          birthdayColor1={theme.message.birthdayColor1}
          birthdayColor2={theme.message.birthdayColor2}
        />
        <div style={{ padding: "10px" }}>
          <DidYouKnowSlider items={didYouKnowItems} interval={10000}
          orientation="portrait" />
        </div>
      </ExtraRow>

      <BottomRow>
        {news && (
          <RSSComponent data={news} textColor={theme.rss.textColor} background={theme.rss.background} fontFamily={theme.rss.fontFamily}
            logoBackground={theme.background} logoTextColor={theme.textColor} 
          />
        )}
      </BottomRow>
    </GridContainer>
  );
};

export default PortraitScreen;
